import { render, staticRenderFns } from "./tabson2.vue?vue&type=template&id=0d1e4a52"
import script from "./tabson2.vue?vue&type=script&lang=js"
export * from "./tabson2.vue?vue&type=script&lang=js"
import style0 from "./tabson2.vue?vue&type=style&index=0&id=0d1e4a52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports